export const AppDrawers = () => {
  return null;
};

export default AppDrawers;
